/* esm.sh - applesauce-core@5.2.0/dist/helpers/profile */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/profile.mjs";
